import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";

import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first} from "rxjs/operators";
import {ReceivablesJob} from "../interface/receivables-job";

@Injectable({
  providedIn: 'root'
})
export class ReceivablesJobService {
  public readonly jobListSubject: ReplaySubject<CountedAndPaginated<ReceivablesJob>>
    = new ReplaySubject<CountedAndPaginated<ReceivablesJob>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadJobList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/receivables-job?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<ReceivablesJob>) => {
        this.jobListSubject.next(result);
      });
  }
  generate(formData: any): Observable<any> {
    return this.httpClient.post(`/rest/crm/receivables-job/generate`, formData)
      .pipe(first());
  }

}
